import { BaseApiService } from '../base/BaseApiService';

/** Resultado retornado pelo backend após importar o CSV de clientes. */
export interface CsvImportResult {
  inseridos: number;
  atualizados: number;
  linhasInseridas: number;
  linhasAtualizadas: number;
  erros: string[];
}

export class WhatsAppClientImportService extends BaseApiService {
  private readonly basePath = '/api/v1/clientes-whatsapp';

  /**
   * Importa clientes e linhas a partir de arquivo CSV no formato largo
   * (uma linha por cliente, colunas LINHA 1…LINHA 20).
   */
  async importClientsFromCsv(file: File): Promise<CsvImportResult> {
    const formData = new FormData();
    formData.append('arquivo', file);

    const response = await this.api.post<CsvImportResult>(
      `${this.basePath}/importar-csv`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );

    return response.data;
  }
}

export const whatsAppClientImportService = new WhatsAppClientImportService();
